// Copyright (c) 2022 by Move Closer

import { ModuleSize } from '@movecloser/page-builder/lib/contracts'

import { ModuleBase, ModuleFactory } from '../../contexts'

import { abstractModuleFactory, getDefaultModuleAlignment } from '../abstract/form'
import { AvailableModuleDriver } from '../allowed'

import { CreationsModule, CreationsModuleData } from './Creations.contracts'

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const creationsContentFactory = (): CreationsModuleData => ({
  image: null,
  pointsCoordinates: []
})

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const creationsFactory: ModuleFactory<CreationsModule> = {
  ...abstractModuleFactory,
  createInitialSize (): ModuleSize {
    return {
      colSpan: 4,
      isResizable: true,
      maxColSpan: 12,
      maxRowSpan: 6,
      minColSpan: 4,
      minRowSpan: 3,
      rowSpan: 3
    }
  },
  createModule (): ModuleBase<CreationsModule> {
    return {
      alignment: getDefaultModuleAlignment(),
      content: creationsContentFactory(),
      driver: AvailableModuleDriver.Creations
    }
  }
}
